import { render, staticRenderFns } from "./VisitorForm.vue?vue&type=template&id=bdc3a458&"
import script from "./VisitorForm.vue?vue&type=script&lang=js&"
export * from "./VisitorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdc3a458')) {
      api.createRecord('bdc3a458', component.options)
    } else {
      api.reload('bdc3a458', component.options)
    }
    module.hot.accept("./VisitorForm.vue?vue&type=template&id=bdc3a458&", function () {
      api.rerender('bdc3a458', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prevent/epidemic/modules/VisitorForm.vue"
export default component.exports